<template>
   <div>
        <div class="each-box" v-for="(item) in printData" :key="item.id">
            <div class="printableTable">
                <div class="row-one">
                  <div class="head-table first">
                    <p class="head-table-text head-small p-header br">{{'到着日'}}</p>
                    <p class="head-table-text head-small p-header br">{{'返品日'}}</p>
                    <p class="head-table-text head-big p-header">{{'検証結果'}}</p>
                  </div>
                  <div class="body-table head-table">
                    <p class="body-table-text body-small head-small  p-content p-content-no-lr br">{{item.arrivedAt}}</p>
                    <p class="body-table-text body-small head-small  p-content p-content-no-lr br">{{item.closingAt}}</p>
                    <p class="body-table-text body-big head-big  p-content">
                      <span class="long-text">{{item.resultCheck}}</span>
                    </p>
                  </div>
                  <span class="bb"></span>
                </div>
                <!-- ONE -->
                <div class="row-two">
                  <div class="head-table row-two-first bb">
                    <p class="head-table-text head-medium p-header br">{{'顧客伝票番号'}}</p>
                    <p class="head-table-text head-small head-status p-header br">{{'ステータス'}}</p>
                    <p class="head-table-text head-big p-header">{{'型番'}}</p>
                  </div>
                  <div class="head-table">
                    <p class="head-table-text head-medium br p-content">
                      <span class="long-text">{{item.des}}</span>
                    </p>
                    <p class="head-table-text head-small head-status br p-content">{{item.status}}</p>
                    <p class="head-table-text head-big  p-content">{{item.model.slice(0, 13)}}</p>
                  </div>
                </div>
                <!-- Two -->
            </div>
        </div>
   </div>
</template>

<script>

import 'jquery'
window.$ = require('jquery')

export default {
  name: 'PrintReturn',
  data: function () {
    return {
      printData: null
    }
  },
  created () {
    this.printData = JSON.parse(this.$route.query.data)
  },
  mounted () {
    window.$('style').remove()
    window.$('link').remove()
    window.$('link').each(function () {
      let href = window.$(this).attr('href')
      let position = href.search('.css')
      if (position !== -1) {
        window.$(this).remove()
      }
    })
    window.$('body').append(`
        <style>
        @media print {
            body {
              width: 60mm;
              margin:0;
            }
            .row-one {
              position: relative;
            }
            span.bb {
              display: block;
              width: 100%;
              height: 1px;
              position: absolute;
              bottom: 0;
            }
            @page {
                size:62mm 29mm !important;
                padding: 0;
                margin: 0;
                padding: 0;
            }
            .printableTable {
                margin:0;
                padding: 0;
                box-sizing: border-box;
                border:1px solid #000;
                margin-bottom: 0;
            }
            .each-box {
              margin-top:1mm;
              page-break-after: always;
            }
            .head-table {
              display: flex;
              position: relative;
              width: 100%;
            }
            body p {
              font-size: xx-small !important;
              margin:0;
              padding:0;
              word-break: break-all;
              line-height: 1;
            }
            .p-content {
                padding: 0.5mm 0;
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 6.5mm;
                max-height: 6.5mm;
            }
            .long-text {
                display: block;
                width: 90%;
                padding-top: 0.5mm;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: revert;
            }
            .p-header {
              font-weight:bold;
              padding-top:0.25mm;
              padding-bottom: 0.25mm;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .head-table-text {
              margin-bottom: 0;
              
            }
            .head-small {
              width: 11mm;
              text-align: center;
              overflow: hidden;
            }
            .head-small.head-status {
              width: 11mm;
            }
            .row-two .head-medium {
              width: 22mm;
              text-align: center;
              overflow: hidden;
            }
            .head-big {
              width:calc( 100% - 22mm );
              text-align: center;
              overflow: hidden;
            }
            .row-two .head-big {
                  width: calc( 100% - 33mm );
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: revert;
                  display: block;
                  text-align: center;
                  position: relative;
                  top: 2mm;
            }
            .br {
              box-shadow: 0.5px 0 0 #000;
            }
            .bb {
              box-shadow: 0 0.5px 0 #000;
            }
            .head-table.first {
              box-shadow: 0 0.5px 0 #000;
            }
            
        }
      </style>
      `
    )
    window.print()
    window.onfocus = function () { window.close() }
  }
}
</script>
